import React from 'react';
import ReactDOM from 'react-dom';
import TawkHelper from './util/tawkHelper';
import retireLegacyServiceWorker from './util/retireLegacyServiceWorker';

const rootEl = document.getElementById('app-site');

// Older Admin releases registered a precaching service worker. It can retain
// an old index.html after a deployment and request hashed chunks which no
// longer exist. Current releases are network-served, so retire that worker and
// its caches without delaying application startup.
retireLegacyServiceWorker();

TawkHelper.initialize();

// Create a reusable render method that we can call more than once
const render = () => {
  // Dynamically import our main App component, and render it
  const MainApp = require('./MainApp').default;
  ReactDOM.render(
    <MainApp />,
    rootEl,
  );
};

if (module.hot) {
  module.hot.accept('./MainApp', () => {
    const MainApp = require('./MainApp').default;
    render(
      <MainApp />,
      rootEl,
    );
  });
}

render();
